import React from 'react';
import { NavLink } from 'react-router-dom';
import { Chip, Stack, Typography } from '@curves/ui-base';
import { OverflowMenu } from '@curves/ui-shared';
import { PRODUCT_DETAIL_ROUTER_URL, PRODUCT_EDIT_ROUTER_URL } from '@Router/routerPath';
import ProductEnabledSwitch from '@Local/Product/List/ProductEnabledSwitch';

/**
 * 商品總覽表格欄位設定（照後端回傳，每個商品一列）
 * @param {{ refreshOverview: () => void, canEdit: boolean }} cellRenderContext
 */
const productTableColumns = [
    {
        cellKey: 'productName',
        headerLabel: '商品名稱/分類',
        minWidth: 260,
        formatCell: (productName, row) => (
            <Stack direction="column" spacing={1}>
                <NavLink to={PRODUCT_DETAIL_ROUTER_URL(row?.productID)}>{productName}</NavLink>
                <Typography component="span" className="product-list__category">
                    {row?.saleCategoryName}
                </Typography>
            </Stack>
        ),
    },
    {
        cellKey: 'variants',
        headerLabel: '規格/SKU',
        minWidth: 280,
        // 每個規格名稱在上、SKU 在下；多於一個規格時才標記主規格
        formatCell: (variants, row) => {
            const list = variants || [];
            return (
                <div className="product-variant-list">
                    {list.map(({ sku, variantName }) => (
                        <div key={sku}>
                            <div className="product-variant-list__name">
                                {variantName && <span>{variantName}</span>}
                                {list.length > 1 && sku === row?.mainSKU && <Chip label="主規格" size="small" color="primary" />}
                            </div>
                            <div className="product-variant-list__sku">{sku}</div>
                        </div>
                    ))}
                </div>
            );
        },
    },
    {
        cellKey: 'isEnabled',
        headerLabel: '是否上架',
        align: 'center',
        formatCell: (isEnabled, row, { refreshOverview }) => (
            <ProductEnabledSwitch productID={row?.productID} isEnabled={isEnabled} onUpdated={refreshOverview} />
        ),
    },
    {
        cellKey: 'action',
        headerLabel: '',
        align: 'right',
        isIcon: true,
        // 列操作選單：檢視明細；有編輯權限才顯示編輯
        formatCell: (_, row, { canEdit }) => (
            <OverflowMenu
                menuData={[
                    { text: '檢視明細', component: NavLink, to: PRODUCT_DETAIL_ROUTER_URL(row?.productID) },
                    ...(canEdit ? [{ text: '編輯', component: NavLink, to: PRODUCT_EDIT_ROUTER_URL(row?.productID) }] : []),
                ]}
            />
        ),
    },
];

export default productTableColumns;
